/* global __CLIENT__ */
import i18n from 'i18next';
import i18nextXHRBackend from 'i18next-xhr-backend';

import { languages, defaultLanguage } from './constants/languages';
import * as i18ns from './constants/i18ns';

if (__CLIENT__) {
  i18n.use(i18nextXHRBackend);
}

const whiteList = Object.keys(languages).map(key => languages[key]);

const nsList = Object.keys(i18ns)
  .map(key => i18ns[key])
  .filter(p => typeof p === 'string');

export const config = {
  fallbackLng: defaultLanguage,
  load: 'currentOnly',
  lowerCaseLng: true,
  whiteList,
  defaultNS: 'common', // the default value is translation cause 404 , so we have to assign a smallest size ns as default.
  ns: nsList,
  backend: {
    // loading i18n scripts from static file
    loadPath: '/i18n/{{lng}}/{{ns}}.json',
  },
  react: {
    wait: true,
  },
};

if (!i18n.isInitialized) i18n.init(config);

export default i18n;



// WEBPACK FOOTER //
// ./app/i18n.js